<template>
<div class="mb-5">
  <h3 class="clearfix mb-5">
    Anmeldung {{ competition.title() }}
  </h3>

  <!-- Classes registration -->
  <classes v-if="step === 0"
    :classes=registeredClasses
    :minimum=minimum
    :registrationId=registrationId
    v-on:update=updateItems
    v-on:next="next"
    v-on:back="back">
  </classes>

  <!-- Confirm form -->
  <confirm v-if="step === 1"
     :competition=competition
     :classes=registeredClasses
     :invoiceRequired=invoiceRequired
     :invoiceAddress=invoiceAddress

     v-on:invoiceRequired=onInvoiceRequired
     v-on:invoiceAddress=onInvoiceAddress
     v-on:back="back"
     v-on:send="send">
  </confirm>

</div>
</template>

<script>

import {Competition, RegisteredClass, RegisteredClassList} from '@/models'
import Classes from '@/components/competitions/registration/Classes'
import TypeSelect from '@/components/competitions/registration/Type'
import Confirm from '@/components/competitions/registration/Confirm'

export default {
  name: 'CompetitionRegistration',

  components: {
    'classes': Classes,
    'typeSelect': TypeSelect,
    'confirm': Confirm
  },

  data () {
    return {
      competition: new Competition(),
      registrationId: null,
      step: 0,
      valid: false,
      registeredClasses: new RegisteredClassList(),
      itemsHash: '',
      total: 0,
      minimum: 0,
      participationType: 'online',
      invoiceRequired: false,
      invoiceAddress: ''
    }
  },

  mounted () {
    if (!this.$route.params.hasOwnProperty('id')) {
      return
    }

    this.competition.id = this.$route.params.id
    this.competition.fetch()

    this.loadRegistration()
  },

  methods: {
    updateItems (registeredClasses) {
      this.items = registeredClasses
    },

    loadRegistration () {
      if (!this.$route.query.id) {
        this.updateHash()
        return
      }

      let that = this
      this.registrationId = this.$route.query.id

      this.axios.get('/registrations/' + this.registrationId).then(function (rsp) {
        rsp.data.payload.registeredClasses.forEach((row) => {
          that.registeredClasses.add(new RegisteredClass({
            ageGroup: row.ageGroup,
            count: row.count,
            type: row.type
          }))
        })

        that.invoiceRequired = rsp.data.invoiceRequired
        that.invoiceAddress = rsp.data.payload.invoiceAddress
        that.minimum = rsp.data.registrationsInvoiced

        that.updateHash()
      })
    },

    onInvoiceRequired: function (required) {
      this.invoiceRequired = required
    },

    onInvoiceAddress: function (address) {
      this.invoiceAddress = address
    },

    modified () {
      return this.getHash() !== this.itemsHash
    },

    getHash () {
      if (!this.items) {
        return
      }

      const md5 = require('md5')
      return md5(JSON.stringify(this.items))
    },

    updateHash () {
      this.itemsHash = this.getHash()
    },

    next () {
      this.$eventHub.$emit('hide')
      this.step++
    },

    back () {
      this.step--

      if (this.step >= 0) {
        return
      }

      this.leave()
    },

    leave (id) {
      let route = {
        name: 'teacher.dashboard'
      }

      if (id) {
        this.registrationId = id
      }

      if (this.$route.params.hasOwnProperty('from')) {
        let from = this.$route.params.from
        let query = from.query

        // do not append id to dashboard route
        if (from.name !== 'teacher.dashboard' && this.registrationId) {
          query.id = this.registrationId
        }

        route = {
          name: from.name,
          query: query,
          params: {from: 'registration'}
        }
      }

      this.$router.push(route)
    },

    send () {
      let method = 'POST'
      let url = '/registrations'
      let body = {
        competitionId: this.competition.id,
        registeredClasses: this.registeredClasses
      }

      if (this.registrationId) {
        method = 'PATCH'
        url += '/' + this.registrationId
        body = {
          registeredClasses: this.registeredClasses
        }
      }

      this.axios.request({
        method: method,
        url: url,
        data: body
      })
        .then((rsp) => {
          this.leave(rsp.data.id)
        })
        .catch((err) => this.$eventHub.$emit('error', err))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/users/competitions/Registration.vue